import { Stack, Typography } from '@mui/material';
import ComptrollerIcon from 'assets/icons/comptroller';

const HeaderTitle = ({ alt, image, title }) => {
	return (
		<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
			{image ? image : <ComptrollerIcon color="#ffff" width="20px" height="20px" />}

			<Typography
				variant="h4"
				sx={{
					color: '#ffff',
				}}
			>
				{title}
			</Typography>
		</Stack>
	);
};

export default HeaderTitle;
